<template>
    <div class="account-abbinamenti">
        <msp-app-bar title="Allenatori"></msp-app-bar>
        <v-container max-width="450px">
            <v-card class="mb-1">
                <v-card-text>
                    Gli allenatori abbinati a te e le richieste ricevute. Puoi revocare un abbinamento
                    o riconsiderare una richiesta rifiutata.
                </v-card-text>
            </v-card>
            <v-alert v-if="errore" type="error" dense>{{ errore }}</v-alert>
            <v-card v-if="caricato && !abbinamenti.length" class="mb-1">
                <v-card-text>Nessun allenatore abbinato.</v-card-text>
            </v-card>
            <v-card v-for="ab in gruppi" :key="ab.id" class="mb-1">
                <v-card-text>
                    <div class="abbinamento-row">
                        <div class="abbinamento-nome">
                            <strong>{{ nome(ab) }}</strong>
                            <span :class="{ 'error--text': ab.status === 'rifiutato' }">{{ etichette[ab.status] }}</span>
                        </div>
                        <div class="flex-1"></div>
                        <div class="abbinamento-azioni">
                            <template v-if="ab.status === 'invitato'">
                                <v-btn text small :disabled="inCorso" @click="rispondi(ab, 'rifiuta')">Rifiuta</v-btn>
                                <v-btn text small color="primary" :disabled="inCorso" @click="rispondi(ab, 'accetta')">Accetta</v-btn>
                            </template>
                            <v-btn v-else-if="ab.status === 'rifiutato'" text small color="primary" :disabled="inCorso" @click="rispondi(ab, 'accetta')">Consenti</v-btn>
                            <span v-else-if="ab.revoca_programmata_il" class="error--text caption">
                                Sarà revocato automaticamente il {{ formatData(ab.revoca_programmata_il) }}
                            </span>
                            <v-btn v-else-if="ab.ruolo_codice !== 'coallenatore'" text small :disabled="inCorso" @click="daRevocare = ab">Revoca</v-btn>
                        </div>
                    </div>
                    <ul v-if="ab.collaboratori.length" class="abbinamento-collaboratori">
                        <li v-for="co in ab.collaboratori" :key="co.id">- {{ nome(co) }}</li>
                    </ul>
                </v-card-text>
            </v-card>
        </v-container>
        <v-dialog :value="!!daRevocare" max-width="400" @input="v => { if (!v) daRevocare = null; }">
            <v-card v-if="daRevocare">
                <v-card-title>Revoca abbinamento</v-card-title>
                <v-card-text>Revocare l'abbinamento con {{ nome(daRevocare) }}? La procedura richiederà qualche giorno, dopodiché non vedrà più i tuoi dati.</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="daRevocare = null">Annulla</v-btn>
                    <v-btn text color="error" :disabled="inCorso" @click="conferma">Revoca</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import mspAppBar from '@components/MspAppBar.vue';
import api from '@mixins/api.js';

const endpoint = `${process.env.VUE_APP_API_BASE_URL}/api/v2/allenatore_atleta.php`;

export default {
    name: 'Abbinamenti',
    components: {
        mspAppBar,
    },
    data() {
        return {
            caricato: false,
            inCorso: false,
            errore: '',
            daRevocare: null,
            etichette: {
                invitato: 'In attesa di risposta',
                attivo: '',
                sospeso: '',
                rifiutato: 'Rifiutato',
            },
        };
    },
    computed: {
        abbinamenti() {
            return this.$store.state.utente.abbinamenti;
        },
        // allenatori con i rispettivi collaboratori; un collaboratore senza head coach in elenco resta a sé
        gruppi() {
            const heads = this.abbinamenti.filter((ab) => ab.ruolo_codice !== 'coallenatore');
            const ids = heads.map((ab) => ab.allenatore_id);
            const collab = this.abbinamenti.filter((ab) => ab.ruolo_codice === 'coallenatore');
            const orfani = collab.filter((ab) => !ids.includes(ab.allenatore2_id));
            return [...heads, ...orfani].map((ab) => ({
                ...ab,
                collaboratori: collab.filter((co) => co.allenatore2_id === ab.allenatore_id),
            }));
        },
    },
    mounted() {
        this.load();
    },
    methods: {
        formatData(data) {
            const [y, m, d] = String(data).split('-');
            return `${d}/${m}/${y}`;
        },
        nome(ab) {
            return `${ab.allenatore_nome || ''} ${ab.allenatore_cognome || ''}`.trim() || 'Allenatore';
        },
        async load() {
            await this.$store.dispatch('utente/loadAbbinamenti');
            this.caricato = true;
        },
        async esegui(url) {
            if (this.inCorso) return;
            this.inCorso = true;
            this.errore = '';
            const result = await api(url, 'PUT');
            this.inCorso = false;
            if (!result || !result.success) {
                this.errore = 'Operazione non riuscita, riprova.';
            }
            // l'elenco si rilegge sempre dal server, anche dopo un errore
            await this.load();
        },
        rispondi(ab, azione) {
            return this.esegui(`${endpoint}?id=${ab.id}&${azione}`);
        },
        async conferma() {
            const ab = this.daRevocare;
            this.daRevocare = null;
            if (ab) await this.esegui(`${endpoint}?id=${ab.id}&revoca`);
        },
    },
};
</script>

<style lang="scss">
.account-abbinamenti {
    .flex-1 {
        flex: 1
    }
    .abbinamento-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
    }
    .abbinamento-nome {
        display: flex;
        flex-direction: column;
    }
    .abbinamento-collaboratori {
        margin: 8px 0 0 16px;
        padding: 0;
        list-style: none;
        font-size: 0.9em;
    }
    .abbinamento-azioni {
        display: flex;
        flex: 1;
    }
}
</style>
